import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './locales/ru.json';
import kk from './locales/kk.json';
import tr from './locales/tr.json';

const resources = {
  ru: { translation: ru },
  kz: { translation: kk },
  tr: { translation: tr },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'ru',
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
